<script setup>
import LoginContainer from '@/components/Auth/LoginContainer';
import { router } from '@inertiajs/vue3';

const props = defineProps({
    dealerships: {
        type: Array,
        default: () => []
    },
    isSuperAdmin: {
        type: Boolean,
        default: false
    }
});

const activate = (hash) => {
    router.post('/select-dealership', { dealership: hash });
};

const logout = () => {
    router.post('/logout');
};
</script>
<template>
<LoginContainer>
    <template #title>{{ $t('auth.select_dealership.title') }}</template>
    <template #subtitle>{{ $t('auth.select_dealership.subtitle') }}</template>

    <div
        v-if="props.dealerships.length"
        class="space-y-2">
        <button
            v-for="dealership in props.dealerships"
            :key="dealership.hash"
            class="w-full flex items-center justify-between rounded-lg border border-line bg-surface px-4 py-3 text-sm font-semibold text-ink hover:border-accent hover:shadow-sm transition text-left"
            @click="activate(dealership.hash)">
            <span class="flex items-center gap-3 min-w-0">
                <v-icon
                    icon="mdi-office-building-outline"
                    size="18"
                    class="text-accent shrink-0" />
                <span class="truncate">{{ dealership.name }}</span>
            </span>
            <v-icon
                icon="mdi-chevron-right"
                size="16"
                class="text-ink-light shrink-0" />
        </button>
    </div>

    <p
        v-else
        class="rounded-lg px-3.5 py-2.5 text-sm bg-warning-soft text-warning">
        {{ $t('auth.select_dealership.no_access') }}
    </p>

    <button
        v-if="props.isSuperAdmin"
        class="w-full mt-3 rounded-lg border border-line bg-canvas px-4 py-3 text-sm font-semibold text-ink-light hover:text-ink hover:border-accent transition"
        @click="activate(null)">
        {{ $t('auth.select_dealership.continue_platform') }}
    </button>

    <div class="flex justify-center mt-6">
        <a
            href="#"
            class="text-xs"
            @click.prevent="logout">{{ $t('label.sign_out') }}</a>
    </div>
</LoginContainer>
</template>
